import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { OwnerLayout } from '../../components/layouts/OwnerLayout';
import { CheckCircle2, Loader2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { api } = useAuth();
  const [status, setStatus] = useState('checking');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) pollStatus();
  }, [sessionId]);

  const pollStatus = async (attempts = 0) => {
    if (attempts >= 5) { setStatus('timeout'); return; }
    try {
      const res = await api.get(`/subscription/status/${sessionId}`);
      if (res.data.payment_status === 'paid') { setStatus('success'); return; }
      setTimeout(() => pollStatus(attempts + 1), 2000);
    } catch (error) {
      setStatus('error');
    }
  };

  return (
    <OwnerLayout>
      <div className="flex items-center justify-center min-h-[60vh]">
        <Card className="max-w-md w-full text-center">
          <CardHeader>
            {status === 'checking' && <Loader2 className="w-16 h-16 mx-auto text-sky-600 animate-spin" />}
            {status === 'success' && <CheckCircle2 className="w-16 h-16 mx-auto text-green-500" />}
            <CardTitle className="text-2xl mt-4">{status === 'checking' ? 'Verificando pago...' : status === 'success' ? '¡Pago completado!' : 'Error en el pago'}</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <p className="text-slate-500">{status === 'checking' ? 'Estamos procesando tu pago' : status === 'success' ? 'Tu suscripción está activa. ¡Disfruta de todas las funciones!' : 'Hubo un problema. Inténtalo de nuevo.'}</p>
            {status !== 'checking' && <Button onClick={() => navigate('/dashboard')} className="w-full">Ir al dashboard</Button>}
          </CardContent>
        </Card>
      </div>
    </OwnerLayout>
  );
};

export default SubscriptionSuccess;
